import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../services/authService';

const ProtectedRoute = () => {
    // Check if the user is authenticated via authService
    if (!authService.isAuthenticated()) {
        // Redirect to the login page if not logged in
        return <Navigate to="/login" replace />;
    }

    // Return the child routes if the user is authenticated
    return <Outlet />;
};

export default ProtectedRoute;
